export const environment = {
  production: true,
  apiBase: 'https://crewing-api.vaderoshipping.se/'
};
